import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import defaultStyles from "./StrikethroughPrice.module.scss";

export type StrikethroughPriceProps = {
  price: string;
  ariaLabel?: string;
  /**
   * Add margin-right spacing. Use when parent container doesn't have flex gap.
   * @default false
   */
  withMargin?: boolean;
};

/**
 * Displays a price with strikethrough styling for showing original/non-discounted prices.
 * Includes accessibility support with aria-label.
 */
export const StrikethroughPrice = ({
  price,
  ariaLabel,
  withMargin = false,
}: StrikethroughPriceProps) => {
  const { t } = useI18nContext();
  const [block] = useModuleBEM(defaultStyles, "StrikethroughPrice", {
    "with-margin": withMargin,
  });

  return (
    <span
      className={block}
      aria-label={
        ariaLabel ?? t("core-packages.hotelCardPrice.originalPriceLabel")
      }
    >
      {price}
    </span>
  );
};
